(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('SmootherMultiplierSearch', SmootherMultiplierSearch);

    SmootherMultiplierSearch.$inject = ['$resource'];

    function SmootherMultiplierSearch($resource) {
        var resourceUrl =  'api/_search/smoother-multipliers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
